<template>
    <div :class="[
        'component',
        'component__progressbar',
        `component__progressbar--${stage}`
    ]">
        <template v-if="title || stage">
            <div class="component__progressbar_top">
                <div class="columns is-variable">
                    <div class="column is-narrow">
                        <div :class="[
                        'component__progressbar_top_title'
                    ]">{{ title }}
                        </div>
                    </div>
                    <div class="column"></div>
                    <div class="column is-narrow is-vbottom">
                        <div :class="[
                        'component__progressbar_top_stage'
                    ]">{{ toCapitalize(fromKebabCaseToString(stage)) }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="component__progressbar_main">
            <div class="columns is-vcentered">
                <div class="column">
                    <div class="component__progressbar_main_progress">
                        <div class="component__progressbar_main_progress_bar" :style="`width: ${ loaded && total ? (loaded * 100 / total).toFixed(0) : progress}%`"></div>
                    </div>
                </div>
                <template v-if="$slots.right">
                    <div class="column is-narrow">
                        <div class="component__progressbar_main_slotright">
                            <slot name="right"></slot>
                        </div>
                    </div>
                </template>
            </div>

        </div>
        <div v-if="loaded !== undefined || total !== undefined" class="component__progressbar_bottom">
            <div class="component__progressbar_bottom_uploadprogress">
                <div class="columns is-variable">
                    <div class="column is-narrow">
                        <div class="component__progressbar_bottom_uploadprogress_percent">{{ loaded && total ? Math.round(loaded * 100 / total) : 0 }}%</div>
                    </div>
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <div class="component__progressbar_bottom_uploadprogress_size">
                            <span class="component__progressbar_bottom_uploadprogress_size_loaded">{{ Math.round(loaded / 1024) }} KB</span>
                            <span class="component__progressbar_bottom_uploadprogress_size_separator">/</span>
                            <span class="component__progressbar_bottom_uploadprogress_size_total">{{ Math.round(total / 1024) }} KB</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'component-progress-bar',
  props: {
    title: {
      type: String,
      default: 'Process'
    },
    stage: {
      type: String,
      required: true
    },
    progress: {
      type: Number,
      default: 0
    },
    progressVisible: {
      type: Boolean,
      default: false
    },
    loaded: {
      type: Number
    },
    total: {
      type: Number
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentprogressbar";
</style>
